import {Vue} from 'ui.vue';

import Const, {ACTION_TYPE_REG, CONFIRM_TYPE_BOT_SPEECH} from './Const';

import 'bxmaker.authuserphone.core';
import './components/BXmakerAuthuserphoneEnter.js';


export class Enter {
    constructor(rootId, data) {
        this.rootId = rootId;
        this.data = data;
        this.rand = data.rand;
        this.instance = null;

        this.initTemplate()
    }


    initTemplate() {
        const context = this;

        this.instance = Vue.createApp({
            name: 'BXmakerAuthuserphoneEnterContainer__' + this.rand,
            key: this.rand,
            data() {
                return {
                    data: context.data,
                    rand: context.data.rand,

                    isEnabledReload: true,
                    isEnabledRedirect: true,

                    isAuthorized: context.data.isAuthorized,

                    isEnabledRegister: context.data.isEnabledRegister,

                    confirmQueue: context.data.confirmQueue,

                    isEnabledConfirmBySmsCode: context.data.isEnabledConfirmBySmsCode,
                    isEnabledConfirmByUserCall: context.data.isEnabledConfirmByUserCall,
                    isEnabledConfirmByBotCall: context.data.isEnabledConfirmByBotCall,
                    isEnabledConfirmByBotSpeech: context.data.isEnabledConfirmByBotSpeech,
                    isEnabledConfirmBySimPush: context.data.isEnabledConfirmBySimPush,

                    isEnabledAuthByLogin: context.data.isEnabledAuthByLogin,
                    isEnabledAuthByEmail: context.data.isEnabledAuthByEmail,

                    isEnabledRegisterFIO: context.data.isEnabledRegisterFIO,
                    isEnabledRegisterLogin: context.data.isEnabledRegisterLogin,
                    isEnabledRegisterEmail: context.data.isEnabledRegisterEmail,
                    isEnabledRegisterPassword: context.data.isEnabledRegisterPassword,

                    isEnabledRestoreByEmail: context.data.isEnabledRestoreByEmail,

                    isEnabledRequestConsent: context.data.isEnabledRequestConsent,

                    isEnabledPhoneMask: context.data.isEnabledPhoneMask,
                    phoneMaskDefaultCountry: context.data.phoneMaskDefaultCountry,
                    phoneMaskCountryTopList: context.data.phoneMaskCountryTopList,


                    actionType: Const.ACTION_TYPE_AUTH, //текущее действие - авторизация  ACTION_TYPE_AUTH, ACTION_TYPE_REG, ACTION_TYPE_FORGET,

                    lastMethod: '',

                    confirmationType: Const.CONFIRM_TYPE_SMS_CODE, // текущий тип подтвреждения - смс кода, звонок от бота и тп


                    isShowConfirm: false, // показывать блок с проверкой
                    isAuthByPassword: context.data.isEnabledAuthByPasswordFirst, // вход по паролю

                    consentLoader: false, // загружается соглашение
                    consentText: false, // текст соглашения
                    isConsentReceived: false, // человек согласен

                    captchaId: '',
                    captchaCode: '',
                    captchaSrc: '',
                    captchaLength: 5,
                    captchaLoader: false,

                    ple: '', // телефон, логин, email
                    fio: '', // ФИО
                    phone: '', // введенный телефон
                    formattedPhone: '', // форматированный номер телефона
                    email: '', // введенный email
                    login: '', // введенный логин
                    password: '', // введенный пароль

                    message: false, // сообщение
                    error: false, // сообщение об ошибкой

                    expandData: {},


                    authByPasswordLoader: false,  //авториазция по паролю
                    authByPhoneLoader: false, // авторизация чреез подтверждение нмоера телефона
                    forgetLoader: false, // восстанволение доступа
                    registerLoader: false, // регистрация

                    // sms
                    smsCodeLength: 4,
                    smsCodeTimeout: 0,
                    smsCode: '',
                    smsCodeError: '',
                    smsCodeStartLoader: false,
                    smsCodeCheckLoader: false,

                    //проверка через звонок от пользователя
                    userCallTo: '',
                    userCallStartLoader: false,
                    userCallCheckLoader: false,
                    userCallTimeout: 0,

                    // звонок от робота
                    botCallCode: '',
                    botCallLength: 4,
                    botCallTimeout: 0,
                    botCallStartLoader: false,
                    botCallCheckLoader: false,

                    // голосовой код
                    botSpeechCode: '',
                    botSpeechLength: 4,
                    botSpeechTimeout: 0,
                    botSpeechStartLoader: false,
                    botSpeechCheckLoader: false,

                    // sim-PUSH
                    simPush: '',
                    simPushTimeout: 0,
                    simPushStartLoader: false,
                    simPushCheckLoader: false,

                };
            },
            computed: {
                localize() {
                    return BX.Vue.getFilteredPhrases('BXMAKER_AUTHUSERPHONE_ENTER_');
                },
                const() {
                    return Const;
                },

                // базовый массив парамтров для запроса по ajax
                baseAjaxData() {
                    let confirmType = '';
                    let confirmValue = '';
                    if (this.isConfirmBySmsCode) {
                        confirmType = this.const.CONFIRM_TYPE_SMS_CODE;
                        confirmValue = this.smsCode;
                    } else if (this.isConfirmByUserCall) {
                        confirmType = this.const.CONFIRM_TYPE_USER_CALL;
                        confirmValue = this.userCallTo;
                    } else if (this.isConfirmByBotCall) {
                        confirmType = this.const.CONFIRM_TYPE_BOT_CALL;
                        confirmValue = this.botCallCode;
                    } else if (this.isConfirmByBotSpeech) {
                        confirmType = this.const.CONFIRM_TYPE_BOT_SPEECH;
                        confirmValue = this.botSpeechCode;
                    } else if (this.isConfirmBySimPush) {
                        confirmType = this.const.CONFIRM_TYPE_SIM_PUSH;
                        confirmValue = this.simPush;
                    }

                    return {
                        siteId: this.data.siteId,
                        template: this.data.template,
                        parameters: this.data.parameters,
                        rand: this.data.rand,

                        expandData: {...this.expandData},
                        confirmType: confirmType,
                        confirmValue: confirmValue,
                        actionType: this.actionType,
                        captchaId: this.captchaId,
                        captchaCode: this.captchaCode,
                    }
                },

                /**
                 * Вернет массив вараинтов подтверждения номера телефона
                 * в нужном нам порядке
                 * @returns {string[]}
                 */
                confirmationList() {
                    let list = this.data.confirmQueue;

                    if (!this.isEnabledConfirmBySmsCode) {
                        list = list.filter(row => row !== this.const.CONFIRM_TYPE_SMS_CODE);
                    }
                    if (!this.isEnabledConfirmByUserCall) {
                        list = list.filter(row => row !== this.const.CONFIRM_TYPE_USER_CALL);
                    }
                    if (!this.isEnabledConfirmByBotCall) {
                        list = list.filter(row => row !== this.const.CONFIRM_TYPE_BOT_CALL);
                    }
                    if (!this.isEnabledConfirmByBotSpeech) {
                        list = list.filter(row => row !== this.const.CONFIRM_TYPE_BOT_SPEECH);
                    }
                    if (!this.isEnabledConfirmBySimPush) {
                        list = list.filter(row => row !== this.const.CONFIRM_TYPE_SIM_PUSH);
                    }

                    if (list.length <= 0) {
                        list.push(this.const.CONFIRM_TYPE_SMS_CODE);
                    }
                    return list;
                },

                startLoader() {
                    return this.smsCodeStartLoader || this.userCallStartLoader || this.botCallStartLoader || this.botSpeechStartLoader || this.simPushStartLoader || this.authByPasswordLoader || this.authByPhoneLoader;
                },

                checkLoader() {
                    return this.smsCodeCheckLoader || this.userCallCheckLoader || this.botCallCheckLoader || this.botSpeechCheckLoader || this.simPushCheckLoader || this.authByPasswordLoader || this.authByPhoneLoader;
                },

                isConfirmBySmsCode() {
                    return this.confirmationType === this.const.CONFIRM_TYPE_SMS_CODE;
                },
                isConfirmByUserCall() {
                    return this.confirmationType === this.const.CONFIRM_TYPE_USER_CALL;
                },
                isConfirmByBotCall() {
                    return this.confirmationType === this.const.CONFIRM_TYPE_BOT_CALL;
                },
                isConfirmByBotSpeech() {
                    return this.confirmationType === this.const.CONFIRM_TYPE_BOT_SPEECH;
                },
                isConfirmBySimPush() {
                    return this.confirmationType === this.const.CONFIRM_TYPE_SIM_PUSH;
                },

                isNeedShowConfirmSmsCode() {
                    return !this.isAuthorized
                        && this.isShowConfirm
                        && this.isConfirmBySmsCode;
                },
                isNeedShowConfirmUserCall() {
                    return !this.isAuthorized
                        && this.isShowConfirm
                        && this.isConfirmByUserCall;
                },
                isNeedShowConfirmBotCall() {
                    return !this.isAuthorized
                        && this.isShowConfirm
                        && this.isConfirmByBotCall;
                },
                isNeedShowConfirmBotSpeech() {
                    return !this.isAuthorized
                        && this.isShowConfirm
                        && this.isConfirmByBotSpeech;
                },
                isNeedShowConfirmSimPush() {
                    return !this.isAuthorized
                        && this.isShowConfirm
                        && this.isConfirmBySimPush;
                },
                isNeedShowChangeConfirm() {
                    return !this.isAuthorized
                        && this.isShowConfirm
                        && this.confirmationList.length > 1;
                },

                // указаны символы с картинки при наличии капчи
                isFullCaptcha() {
                    if (!this.captchaId) {
                        return true;
                    }

                    if (this.captchaLength === this.captchaCode.toString().length) {
                        return true;
                    }

                    return false;
                },

                // процесс авторизациии
                actionTypeIsAuth() {
                    return this.actionType === Const.ACTION_TYPE_AUTH;
                },
                // провесс регистрации
                actionTypeIsReg() {
                    return this.actionType === Const.ACTION_TYPE_REG;
                },
                // процесс восстановления пароля
                actionTypeIsForget() {
                    return this.actionType === Const.ACTION_TYPE_FORGET;
                },

            },
            watch: {
                actionType(val, oldVal) {
                    BX.Vue.event.$emit('BXmakerAuthuserphoneEnterChangeActionType', {
                        value: val,
                        oldValue: oldVal,
                        rand: this.rand,
                    });
                },
                confirmationType(val, oldVal) {
                    BX.Vue.event.$emit('BXmakerAuthuserphoneEnterChangeConfirmationType', {
                        value: val,
                        oldValue: oldVal,
                        rand: this.rand,
                    });
                },
                isShowConfirm(val, oldVal) {
                    BX.Vue.event.$emit('BXmakerAuthuserphoneEnterChangeShowConfirm', {
                        value: val,
                        oldValue: oldVal,
                        rand: this.rand,
                    });
                },
                isAuthByPassword(val, oldVal) {
                    BX.Vue.event.$emit('BXmakerAuthuserphoneEnterChangeIsAuthByPassword', {
                        value: val,
                        oldValue: oldVal,
                        rand: this.rand,
                    });
                }

            },
            created() {
                if (this.confirmationList.length > 0 && this.confirmationList[0] !== this.confirmationType) {
                    this.setConfirmType(this.confirmationList[0]);
                }

                if (location.hash === '#reg' && this.isEnabledRegister) {
                    this.toRegistration();
                }

            },
            methods: {
                resetExpandData() {
                    this.expandData = {};
                },
                setExpandData(name, value) {
                    this.expandData[name] = value;
                },

                // вклчюение/отключение перезагурзки страницы после авторизации
                setIsEnabledReload(flag) {
                    this.isEnabledReload = !!flag;
                },

                // включаение/отключение редиректа после авторизации
                setIsEnabledRedirect(flag) {
                    this.isEnabledRedirect = !!flag;
                },


                // установка поля - фио
                setFIO(value) {
                    this.fio = value;
                },

                // установка поля - телефон, логин, email
                setPLE(value) {
                    this.ple = value;
                },

                //  включение/отклчюение входа по паролю
                setIsAuthByPassword(value) {
                    this.isAuthByPassword = value;
                },

                // установка телеофна
                setPhone(value) {
                    this.phone = value;
                },


                setFormattedPhone(value) {
                    this.formattedPhone = value;
                },
                setLogin(value) {
                    this.login = value;
                },

                setEmail(value) {
                    this.email = value;
                },
                setPassword(value) {
                    this.password = value;
                },

                setIsAuthorized(value) {
                    this.isAuthorized = !!value;
                },

                // установка/снятие флага процесса авториазци по паролю
                setAuthByPasswordLoader(value) {
                    this.authByPasswordLoader = !!value;
                },

                // установка/снятие флага процесса авториазци по паролю
                setAuthByPhoneLoader(value) {
                    this.authByPhoneLoader = !!value;
                    this.smsCodeCheckLoader = !!value;
                    this.botCallCheckLoader = !!value;
                    this.botSpeechCheckLoader = !!value;
                    this.userCallCheckLoader = !!value;
                    this.simPushCheckLoader = !!value;
                },

                // установка/снятие флага выполнение восстановления доступа
                setForgetLoader(value) {
                    this.forgetLoader = !!value;
                    this.smsCodeCheckLoader = !!value;
                    this.botCallCheckLoader = !!value;
                    this.botSpeechCheckLoader = !!value;
                    this.userCallCheckLoader = !!value;
                    this.simPushCheckLoader = !!value;
                },

                // установка/снятие флага выполнения регистрации
                setRegisterLoader(value) {
                    this.registerLoader = !!value;
                    this.smsCodeCheckLoader = !!value;
                    this.botCallCheckLoader = !!value;
                    this.botSpeechCheckLoader = !!value;
                    this.userCallCheckLoader = !!value;
                    this.simPushCheckLoader = !!value;
                },


                // sms -------------------------
                setSmsCodeLength(value) {
                    this.smsCodeLength = value;
                },
                setSmsCodeTimeout(value) {
                    this.smsCodeTimeout = value;
                },
                setSmsCode(value) {
                    this.smsCode = value;
                },
                setSmsCodeError(value) {
                    this.smsCodeError = value;
                },
                setSmsCodeStartLoader(value) {
                    this.smsCodeStartLoader = value;
                },
                setSmsCodeCheckLoader(value) {
                    this.smsCodeCheckLoader = value;
                },


                //проверка через звонок от пользователя
                setUserCallTo(value) {
                    this.userCallTo = value;
                },
                setUserCallStartLoader(value) {
                    this.userCallStartLoader = value;
                },
                setUserCallCheckLoader(value) {
                    this.userCallCheckLoader = value;
                },
                setUserCallTimeout(value) {
                    this.userCallTimeout = value;
                },

                // звонок от робота
                setBotCallCode(value) {
                    this.botCallCode = value;
                },
                setBotCallLength(value) {
                    this.botCallLength = value;
                },
                setBotCallTimeout(value) {
                    this.botCallTimeout = value;
                },
                setBotCallStartLoader(value) {
                    this.botCallStartLoader = value;
                },
                setBotCallCheckLoader(value) {
                    this.botCallCheckLoader = value;
                },

                //голосовой код
                setBotSpeechCode(value) {
                    this.botSpeechCode = value;
                },
                setBotSpeechLength(value) {
                    this.botSpeechLength = value;
                },
                setBotSpeechTimeout(value) {
                    this.botSpeechTimeout = value;
                },
                setBotSpeechStartLoader(value) {
                    this.botSpeechStartLoader = value;
                },
                setBotSpeechCheckLoader(value) {
                    this.botSpeechCheckLoader = value;
                },

                // SIM-push
                setSimPush(value) {
                    this.simPush = value;
                },
                setSimPushTimeout(value) {
                    this.simPushTimeout = value;
                },
                setSimPushStartLoader(value) {
                    this.simPushStartLoader = value;
                },
                setSimPushCheckLoader(value) {
                    this.simPushCheckLoader = value;
                },


                // при клике на кнпоку  другйо вариант подтверждения
                changeConfirmType() {
                    let list = this.confirmationList;
                    let current = this.confirmationType;
                    if (list.length > 1) {
                        let newconfirmationType = list[0];
                        let index = list.indexOf(current);
                        if (index > -1 && !!list[index + 1]) {
                            newconfirmationType = list[index + 1];
                        }
                        if (newconfirmationType !== current) {
                            this.setConfirmType(newconfirmationType);
                            this.startConfirm();
                        }
                    }
                },

                // установка текущего варианта подтверждения
                setConfirmType(type) {
                    let list = this.confirmationList;
                    if (~list.indexOf(type)) {
                        this.resetMessage();
                        this.confirmationType = type;
                    }
                },

                //Показать блок подтверждения
                showConfirm() {
                    this.isShowConfirm = true;
                },
                // скрыть блок подтверждения
                hideConfirm() {
                    this.isShowConfirm = false;
                },

                // сброс мообщений об ошибках или успехах
                resetMessage() {
                    this.message = false;
                    this.error = false;
                },

                //вывод ошибки
                setError(msg) {
                    this.message = msg;
                    this.error = true;
                },

                //вывод сообщения
                setMessage(msg) {
                    this.message = msg;
                    this.error = false;
                },


                // разбор ошибок
                parseError(error) {
                    if (error.more && error.more.formattedPhone) {
                        this.setFormattedPhone(error.more.formattedPhone);
                    }

                    switch (error.code) {
                        // case 'ERROR_INVALID_SESSID': {
                        //     if(error.more.sessid)
                        //     {
                        //         BX.message({'bitrix_sessid' : error.more.sessid});
                        //     }
                        //
                        //     break;
                        // }
                        case 'ERROR_NEED_CONFIRM': {
                            this.resetCaptcha();
                            this.startConfirm();
                            this.showConfirm();
                            break;
                        }
                        case 'ERROR_INVALID_PHONE': {
                            this.resetCaptcha();
                            this.hideConfirm();
                            this.setError(error.msg);
                            break;
                        }
                        case 'ERROR_NEED_WAIT_TIMEOUT': {
                            this.resetCaptcha();
                            this.showConfirm();

                            if (this.confirmationType === this.const.CONFIRM_TYPE_SMS_CODE) {
                                this.setSmsCodeTimeout(error.more.timeout);
                                this.setSmsCodeLength(error.more.length);

                            } else if (this.confirmationType === this.const.CONFIRM_TYPE_USER_CALL) {
                                this.setUserCallTimeout(error.more.timeout);
                                if (error.more.callTo) {
                                    this.setUserCallTo(error.more.callTo);
                                }
                            } else if (this.confirmationType === this.const.CONFIRM_TYPE_BOT_CALL) {
                                this.setBotCallTimeout(error.more.timeout);
                                this.setBotCallLength(error.more.length);
                            } else if (this.confirmationType === this.const.CONFIRM_TYPE_BOT_SPEECH) {
                                this.setBotSpeechTimeout(error.more.timeout);
                                this.setBotSpeechLength(error.more.length);
                            } else if (this.confirmationType === this.const.CONFIRM_TYPE_SIM_PUSH) {
                                this.setSimPushTimeout(error.more.timeout);
                                this.setSimPush(1);
                            }

                            break;
                        }
                        case 'ERROR_NEED_CAPTCHA': {
                            this.setError(error.msg);
                            this.setCaptchaCode('');
                            this.setCaptchaId(error.more.captchaId)
                            this.setCaptchaSrc(error.more.captchaSrc)
                            this.setCaptchaLength(error.more.captchaLength)

                            break;
                        }
                        case 'ERROR_INVALID_SMS_CODE': {
                            this.setSmsCode('');
                            this.setSmsCodeError(error.msg);
                            break;
                        }
                        case 'SERVICE_ERROR_UNKNOWN':
                        case 'SERVICE_ERROR_RESPONSE': {
                            this.resetCaptcha();
                            this.showConfirm();
                            this.setError(error.msg);
                            break;
                        }
                        default: {
                            this.setError(error.msg);
                            break;
                        }
                    }
                },

                // переключить на регистрацию
                toRegistration() {
                    this.hideConfirm();
                    this.resetMessage();
                    this.resetCaptcha();
                    this.actionType = Const.ACTION_TYPE_REG;
                    this.loadConsent();
                },

                toAuth() {
                    this.hideConfirm();
                    this.resetMessage();
                    this.resetCaptcha();
                    this.actionType = Const.ACTION_TYPE_AUTH;
                },

                toForget() {
                    this.hideConfirm();
                    this.resetMessage();
                    this.resetCaptcha();
                    this.actionType = Const.ACTION_TYPE_FORGET;
                },

                //загрузка соглашения
                loadConsent() {
                    if (!this.isEnabledRequestConsent) {
                        return false;
                    }

                    if (this.consentLoader || this.consentText) {
                        return false;
                    }

                    this.lastMethod = this.loadConsent;

                    this.consentLoader = true;

                    this.resetMessage();

                    let requestData = Object.freeze({
                        sessid: BX.bitrix_sessid(),
                        siteId: this.data.siteId,
                        template: this.data.template,
                        parameters: this.data.parameters,
                        expandData: {...this.expandData},
                        rand: this.data.rand,
                        method: 'getConsent',
                    });

                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {

                            BX.Vue.event.$emit('BXmakerAuthuserphoneEnterAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            if (r.response) {

                                this.consentText = r.response.html;

                            } else {
                                this.parseError(r.error);
                            }

                            this.consentLoader = false;
                        },
                        onfailure: (e) => {
                            this.consentLoader = false;
                        }
                    });

                },

                // установить согласие
                consentAgree() {
                    this.isConsentReceived = true;
                },

                // снять согласие
                consentDisagree() {
                    this.isConsentReceived = false;
                },

                /**
                 * Запрос новой капчи
                 */
                refreshCaptcha() {
                    this.resetMessage();

                    this.captchaLoader = true;

                    let requestData = Object.freeze({
                        sessid: BX.bitrix_sessid(),
                        siteId: this.data.siteId,
                        template: this.data.template,
                        parameters: this.data.parameters,
                        expandData: {...this.expandData},
                        rand: this.data.rand,

                        method: 'refreshCaptcha',
                    });


                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {

                            BX.Vue.event.$emit('BXmakerAuthuserphoneEnterAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            if (r.response) {

                                this.captchaId = r.response.captchaId;
                                this.captchaSrc = r.response.captchaSrc;
                                this.captchaLength = r.response.captchaLength;
                                this.captchaCode = '';

                            } else {
                                this.parseError(r.error);
                            }

                            this.captchaLoader = false;
                        },
                        onfailure: (e) => {
                            this.captchaLoader = false;
                        }
                    });
                },

                /**
                 * СБрос состояния капчи
                 */
                resetCaptcha() {
                    this.captchaCode = '';
                    this.captchaId = '';
                    this.captchaSrc = '';
                },

                /**
                 * СБрос состояния капчи
                 */
                hideCaptcha() {
                    this.captchaSrc = false;
                },

                //установка  кода с картиник
                setCaptchaCode(value) {
                    this.captchaCode = value;
                },
                setCaptchaId(value) {
                    this.captchaId = value;
                },
                setCaptchaSrc(value) {
                    this.captchaSrc = value;
                },
                setCaptchaLength(value) {
                    this.captchaLength = +value;
                },

                //Запуск начала проверки
                startConfirm() {
                    switch (this.confirmationType) {
                        case this.const.CONFIRM_TYPE_SMS_CODE: {
                            this.startConfirmSmsCode();
                            break;
                        }
                        case this.const.CONFIRM_TYPE_USER_CALL: {
                            this.startConfirmUserCall();
                            break;
                        }
                        case this.const.CONFIRM_TYPE_BOT_CALL: {
                            this.startConfirmBotCall();
                            break;
                        }
                        case this.const.CONFIRM_TYPE_BOT_SPEECH: {
                            this.startConfirmBotSpeech();
                            break;
                        }
                        case this.const.CONFIRM_TYPE_SIM_PUSH: {
                            this.startConfirmSimPush();
                            break;
                        }
                    }
                },

                /**
                 * Начало проверки через код в смс
                 */
                startConfirmSmsCode() {
                    if (this.smsCodeStartLoader) {
                        return false;
                    }

                    this.resetMessage();
                    // this.hideCaptcha();

                    this.setSmsCodeStartLoader(true);

                    let requestData = Object.freeze({
                        ...this.baseAjaxData,
                        sessid: BX.bitrix_sessid(),
                        method: 'startConfirm',
                        phone: this.phone,
                    });


                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {

                            BX.Vue.event.$emit('BXmakerAuthuserphoneEnterAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            this.resetCaptcha();

                            if (r.response) {
                                this.setFormattedPhone(r.response.formattedPhone);
                                this.setSmsCodeLength(r.response.length);
                                this.setSmsCodeTimeout(r.response.timeout);

                                this.resetCaptcha();
                                this.showConfirm();

                            } else {
                                this.parseError(r.error);
                            }

                            this.setSmsCodeStartLoader(false);
                        },
                        onfailure: (e) => {
                            this.setSmsCodeStartLoader(false);
                        }
                    });
                },

                /**
                 * Начало проверки через звонок от пользователя
                 */
                startConfirmUserCall() {
                    if (this.userCallStartLoader) {
                        return false;
                    }
                    this.resetMessage();
                    // this.hideCaptcha()


                    this.setUserCallStartLoader(true);

                    let requestData = Object.freeze({
                        ...this.baseAjaxData,
                        sessid: BX.bitrix_sessid(),
                        method: 'startConfirm',
                        phone: this.phone,
                    });

                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {

                            BX.Vue.event.$emit('BXmakerAuthuserphoneEnterAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            this.resetCaptcha();

                            if (r.response) {

                                this.setFormattedPhone(r.response.formattedPhone);

                                this.setUserCallTo(r.response.callTo);
                                this.setUserCallTimeout(r.response.timeout);

                                this.resetCaptcha()

                                this.showConfirm();

                            } else {
                                this.parseError(r.error);
                            }

                            this.setUserCallStartLoader(false);
                        },
                        onfailure: (e) => {
                            this.setUserCallStartLoader(false);
                        }
                    });
                },

                /**
                 * Начало подтверждения через звонок от бота
                 */
                startConfirmBotCall() {
                    if (this.botCallStartLoader) {
                        return false;
                    }
                    this.resetMessage();
                    // this.hideCaptcha();

                    this.setBotCallStartLoader(true);

                    let requestData = Object.freeze({
                        ...this.baseAjaxData,
                        sessid: BX.bitrix_sessid(),
                        method: 'startConfirm',
                        phone: this.phone,
                    });

                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {
                            BX.Vue.event.$emit('BXmakerAuthuserphoneEnterAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            this.resetCaptcha();

                            if (r.response) {

                                this.setFormattedPhone(r.response.formattedPhone);
                                this.setBotCallLength(r.response.length);
                                this.setBotCallTimeout(r.response.timeout);

                                this.resetCaptcha()

                                this.showConfirm();

                            } else {
                                this.parseError(r.error);
                            }

                            this.setBotCallStartLoader(false);
                        },
                        onfailure: (e) => {
                            this.setBotCallStartLoader(false);
                        }
                    });
                },

                /**
                 * Начало подтверждения через голосовой код
                 */
                startConfirmBotSpeech() {
                    if (this.botSpeechStartLoader) {
                        return false;
                    }
                    this.resetMessage();
                    // this.hideCaptcha();

                    this.setBotSpeechStartLoader(true);

                    let requestData = Object.freeze({
                        ...this.baseAjaxData,
                        sessid: BX.bitrix_sessid(),
                        method: 'startConfirm',
                        phone: this.phone,
                    });

                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {
                            BX.Vue.event.$emit('BXmakerAuthuserphoneEnterAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            this.resetCaptcha();

                            if (r.response) {

                                this.setFormattedPhone(r.response.formattedPhone);
                                this.setBotSpeechLength(r.response.length);
                                this.setBotSpeechTimeout(r.response.timeout);

                                this.resetCaptcha()

                                this.showConfirm();

                            } else {
                                this.parseError(r.error);
                            }

                            this.setBotSpeechStartLoader(false);
                        },
                        onfailure: (e) => {
                            this.setBotSpeechStartLoader(false);
                        }
                    });
                },
                /**
                 * Начало подтверждения через SIM-push
                 */
                startConfirmSimPush() {
                    if (this.simPushStartLoader) {
                        return false;
                    }
                    this.resetMessage();
                    // this.hideCaptcha();

                    this.setSimPushStartLoader(true);

                    let requestData = Object.freeze({
                        ...this.baseAjaxData,
                        sessid: BX.bitrix_sessid(),
                        method: 'startConfirm',
                        phone: this.phone,
                    });

                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {
                            BX.Vue.event.$emit('BXmakerAuthuserphoneEnterAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            this.resetCaptcha();

                            if (r.response) {

                                this.setFormattedPhone(r.response.formattedPhone);
                                this.setSimPushTimeout(r.response.timeout);
                                this.setSimPush(1);

                                this.resetCaptcha()

                                this.showConfirm();

                            } else {
                                this.parseError(r.error);
                            }

                            this.setSimPushStartLoader(false);
                        },
                        onfailure: (e) => {
                            this.setSimPushStartLoader(false);
                        }
                    });
                },

                //  Авторизация
                authByPassword() {
                    if (this.authByPasswordLoader) {
                        return false;
                    }

                    this.resetMessage();
                    this.setAuthByPasswordLoader(true);

                    let requestData = Object.freeze({
                        ...this.baseAjaxData,
                        sessid: BX.bitrix_sessid(),
                        method: 'authByPassword',
                        ple: this.ple,
                        password: this.password,
                    });

                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {
                            BX.Vue.event.$emit('BXmakerAuthuserphoneEnterAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            this.resetCaptcha();

                            if (r.response) {

                                this.setIsAuthorized(true);
                                this.afterAuthSuccessful(r.response);

                            } else {
                                this.parseError(r.error);
                            }

                            this.setAuthByPasswordLoader(false);
                        },
                        onfailure: (e) => {
                            this.setAuthByPasswordLoader(false);
                        }
                    });
                },

                //  Авторизация
                authByPhone() {
                    if (this.authByPhoneLoader) {
                        return false;
                    }

                    this.resetMessage();
                    this.setAuthByPhoneLoader(true);

                    let requestData = Object.freeze({
                        ...this.baseAjaxData,
                        sessid: BX.bitrix_sessid(),
                        method: 'authByPhone',
                        phone: this.phone,
                    });

                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {
                            BX.Vue.event.$emit('BXmakerAuthuserphoneEnterAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            this.resetCaptcha();

                            if (r.response) {
                                this.afterAuthSuccessful(r.response);

                            } else {
                                this.parseError(r.error);
                                this.setAuthByPhoneLoader(false);
                            }


                        },
                        onfailure: (e) => {
                            this.setAuthByPhoneLoader(false);
                        }
                    });
                },

                //  отработка ответа после успешно авторизации и выполнение редиректов или переагрузки страницы
                afterAuthSuccessful(data) {
                    if (data.redirect && this.isEnabledRedirect) {
                        location.href = data.redirect;
                    } else if (data.reload && this.isEnabledReload) {
                        location.reload();
                    } else {
                        this.setIsAuthorized(true);
                        this.setAuthByPhoneLoader(false);
                    }
                },

                // восстановление пароля
                forget() {
                    if (this.forgetLoader) {
                        return false;
                    }

                    this.resetMessage();
                    this.setForgetLoader(true);

                    let requestData = Object.freeze({
                        ...this.baseAjaxData,
                        sessid: BX.bitrix_sessid(),
                        method: 'forget',
                        phone: this.phone,
                        email: this.email,
                    });

                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {
                            BX.Vue.event.$emit('BXmakerAuthuserphoneEnterAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            this.resetCaptcha();

                            if (r.response) {

                                this.setMessage(r.response.msg);

                                if (r.response.isAuthorized) {
                                    this.setIsAuthorized(true);
                                    this.afterAuthSuccessful(r.response);
                                }

                            } else {
                                this.parseError(r.error);
                            }

                            this.setForgetLoader(false);
                        },
                        onfailure: (e) => {
                            this.setForgetLoader(false);
                        }
                    });
                },

                // регистрация
                register() {
                    if (this.registerLoader) {
                        return false;
                    }

                    this.resetMessage();
                    this.setRegisterLoader(true);

                    let requestData = Object.freeze({
                        ...this.baseAjaxData,
                        sessid: BX.bitrix_sessid(),
                        method: 'register',
                        fio: this.fio,
                        phone: this.phone,
                        login: this.login,
                        email: this.email,
                        password: this.password,
                        consentUrl: window.location.href
                    });

                    BX.ajax({
                        url: this.data.ajaxUrl,
                        method: 'POST',
                        dataType: 'json',
                        timeout: 10,
                        async: true,
                        cache: false,
                        data: requestData,
                        onsuccess: (r) => {
                            BX.Vue.event.$emit('BXmakerAuthuserphoneEnterAjaxResponse', {
                                request: requestData,
                                result: r,
                            });

                            this.resetCaptcha();

                            if (r.response) {

                                this.setIsAuthorized(true);
                                this.afterAuthSuccessful(r.response);

                            } else {
                                this.parseError(r.error);
                            }

                            this.setRegisterLoader(false);
                        },
                        onfailure: (e) => {
                            this.setRegisterLoader(false);
                        }
                    });
                },


                //првоерка подтвреждения,  то есть будет произведена повторная попытка авторизации, регистраиции, восстанволения доступа с данным полученными при подтвреждении
                checkConfirm() {
                    switch (this.actionType) {
                        case Const.ACTION_TYPE_AUTH: {
                            this.authByPhone();
                            break;
                        }
                        case Const.ACTION_TYPE_REG: {
                            this.register();
                            break;
                        }
                        case Const.ACTION_TYPE_FORGET: {
                            this.forget();
                            break;
                        }
                    }
                },
                onCommandCallUserCheck() {
                    if (this.confirmationType !== this.const.CONFIRM_TYPE_USER_CALL) {
                        return true;
                    }
                    if (!this.isShowConfirm) {
                        return true;
                    }
                    this.checkConfirm();
                },


            },
            template: `<BXmakerAuthuserphoneEnter :key="data.rand" />`,
        });

        this.instance.mount('#' + this.rootId);

        return new Promise((resolve, reject) => resolve());
    }

}